import { Response } from 'miragejs';
import { IErrorPayload } from '../api';
import { AppErrorKeys } from '../errors/error';

export const getErrorResponse = (errorKey: AppErrorKeys, statusCode = 400, payload?: IErrorPayload): Response => {
  return new Response(statusCode, {}, { errorKey: errorKey, httpStatusCode: statusCode, message: errorKey, payload: payload });
};

export const getSuccessEmptyResponse = () => new Response(200);
